import request from '@/utils/request'

//上传图片路径
const uploadPath = process.env.VUE_APP_BASE_API + 'file/uploadFile'
export { uploadPath }

// 获取城市地区
export function districtList(districtId) {
  return request({
    url: '/system/district/list/' + districtId,
    method: 'get',
  })
}
// 地址树
export function addressTree(query) {
  return request({
    url: '/power/system/address/addressTree',
    method: 'get',
    params: query,
  })
}

// 地址识别
export function addressParse(query) {
  return request({
    url: '/power/system/address/addressParse',
    method: 'get',
    params: query,
  })
}

// 营业执照 智能识别
export function ocr(data) {
  return request({
    url: '/power/system/ocr/businessLicense',
    method: 'post',
    data,
  })
}

// 查询操作日志列表
export function operLoglist(query) {
  return request({
    url: '/log/operLog/list',
    method: 'get',
    params: query,
  })
}
// 查看物流
export function kuaidiPackageTrack(query) {
  return request({
    url: 'power/system/kuaidi/package/track',
    method: 'get',
    params: query,
  })
}

// 消息
export function homepageNoticeList(query) {
  return request({
    url: 'power/homepage/notice/list',
    method: 'get',
    params: query,
  })
}

// 常用功能_添加
export function homeMenuAdd(query) {
  return request({
    url: '/power/homepage/homeMenu/add',
    method: 'get',
    params: query,
  })
}

// 常用功能_列表
export function homeMenuList(query) {
  return request({
    url: '/power/homepage/homeMenu/list',
    method: 'get',
    params: query,
  })
}

// 快捷查询_菜单列表
export function homepageMenuList(query) {
  return request({
    url: '/power/homepage/menu/list',
    method: 'get',
    params: query,
  })
}

// 查看物流-包裹
export function stockoutLogistics(query) {
  return request({
    url: '/power/stock/order/stockout/logistics',
    method: 'get',
    params: query,
  })
}

// 经营概况-店铺库存
export function shopHomeOverviewList(query) {
  return request({
    url: '/power/data/shop/home/overview/list',
    method: 'get',
    params: query,
  })
}

// 经营概况-全域业绩分析
export function performanceHomeOverviewList(query) {
  return request({
    url: '/power/data/shop/performance/home/overview/list',
    method: 'get',
    params: query,
  })
}

// 经营概况-仓储库存
export function stockHomeOverviewList(query) {
  return request({
    url: '/power/data/sku/stock/home/overview/list',
    method: 'get',
    params: query,
  })
}
